import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import * as reducers from './reactReducers'
import * as AspireFeedback from './AspireFeedback'
import * as AspireSamples from './AspireSamples'
import * as AspireEditDynamicData from './AspireEditDynamicData'
import * as AspireResumeGap from './AspireResumeGap'
import * as DetailedFeedback from './DetailedFeedback'
import * as Login from './Login'
import * as Edit from './Edit'
import * as CustomerFeedback from './CustomerFeedback'
import * as ImageUpload from './ImageUpload'
import * as Tour from '../tour/Reducer'

import * as AccountStates from '@vmockinc/dashboard/Account/states'
import * as DashboardStates from '@vmockinc/dashboard/Dashboard/states'
import * as AspireStates from '@vmockinc/dashboard/Aspire/states'
import * as AspireReducers from '@vmockinc/dashboard/Aspire/reducers'
import * as NavbarReducers from '@vmockinc/dashboard/Navbar/reducers'
import * as userCustomizations from '@vmockinc/dashboard/Dashboard/reducers/UserCustomizations'
import * as JobsReducers from '@vmockinc/dashboard/Jobs/reducers'
import * as ResumeReducers from '@vmockinc/dashboard/Resume/reducers'
import * as CFReducers from '@vmockinc/dashboard/CareerFit/reducers'
import * as InternalNavigation from '@vmockinc/dashboard/Common/commonComps/ProductNavigation/reducers/InternalNavigation'
import { settings } from '@vmockinc/dashboard/Dashboard/reducers/Settings'
import {
  aspireUploadCount,
  aspirePrevSession,
} from '@vmockinc/dashboard/Aspire/reducers'
import {
  epInterviews,
  epCustomizations,
} from '@vmockinc/dashboard/EP/reducers/epReducer'
import { cmc } from '@vmockinc/dashboard/Dashboard/reducers/CMC'
import { dashboardHome } from '@vmockinc/dashboard/Dashboard/reducers/DashboardHome'
import { cfPreferences } from '@vmockinc/dashboard/CareerFit/reducers/preferences'
import { helpSection } from '@vmockinc/dashboard/HelpSection/reducer'

import $ from 'jquery'

$.extend(reducers, userCustomizations)
$.extend(reducers, AccountStates)
$.extend(reducers, DashboardStates)
$.extend(reducers, AspireStates)
$.extend(reducers, AspireReducers)
$.extend(reducers, NavbarReducers)
$.extend(reducers, JobsReducers)
$.extend(reducers, ResumeReducers)
$.extend(reducers, CFReducers)

$.extend(reducers, AspireFeedback)
$.extend(reducers, AspireSamples)
$.extend(reducers, AspireEditDynamicData)
$.extend(reducers, AspireResumeGap)
$.extend(reducers, DetailedFeedback)
$.extend(reducers, Login)
$.extend(reducers, Edit)
$.extend(reducers, ImageUpload)
$.extend(reducers, Tour)
$.extend(reducers, CustomerFeedback)
$.extend(reducers, InternalNavigation)
$.extend(reducers, {
  aspireUploadCount,
  aspirePrevSession,
  epCustomizations,
  epInterviews,
  cmc,
  dashboardHome,
  cfPreferences,
  helpSection,
  settings,
})

export default combineReducers(reducers)
